import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Review.title',
    defaultMessage: 'Time to grab a coffee. We’ll be right back',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Review.subtitle',
    defaultMessage: 'Thanks for your submission. We can’t wait to listen to your demos.\nOur sound engineers and sourcing team will review your studio demo and audition tape. \n\nWe’ll reach out to you via e-mail if we need additional information and once we’ve assessed your application. If we approve your application, you can continue with the last few steps to join VoiceArchive’s handpicked pool of voice talents officially. \n\nThe review process usually takes a couple of weeks. While you wait, you can familiarize yourself with our services and processes <link>here</link>.',
  },
  titleInReview: {
    id: 'containers.SupplierProfile.components.Review.title.inReview',
    defaultMessage: 'Alright, here is the deal',
  },
  titleAccepted: {
    id: 'containers.SupplierProfile.components.Review.title.accepted',
    defaultMessage: 'One small step for mankind,\none giant leap for a voice talent.',
  },
  subtitleAccepted: {
    id: 'containers.SupplierProfile.components.Review.subtitle.accepted',
    defaultMessage: 'We\'ve approved your application, so you\'re ready to move on. From here, you can upload additional demos (by clicking on \'Demos\' in the navigation sidebar) and proceed to the next step, covering rates. Refill your coffee cup, and let\'s go!',
  },
})
